import { withStyles } from '@material-ui/core';

const styles = withStyles(() => ({
  paper: {
    padding: 32,
    width: '60vw',
    maxWidth: 1024,
    margin: '32px auto 0',
    borderRadius: 4,

    '& .title': {
      textAlign: 'left',
      marginBottom: 16,
    },

    '& .uncompleted-message': {
      color: '#dc3f53',
      marginTop: 8,
    },

    '& .text': {
      fontWeight: 400,
      fontSize: 16,
      marginBottom: 16,
      color: '#546E7A',
    },

    '& .price': {
      color: '#4CAF50',
      margin: '8px 0 0',
    },

    '& .image': {
      maxWidth: '100%',
    },

    '& .content-preview': {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },

    '& .share-link-title': {
      margin: '8px 0 4px',
    },

    '& .deliver-section': {
      margin: '12px 0',
      padding: 20,
      backgroundColor: '#F9FAFB',
      border: '1px solid #ECEFF1',
      borderRadius: 8,
      display: 'flex',
      justifyContent: 'space-between',

      '@media (max-width: 960px)': {
        flexDirection: 'column',
        gap: 16,
      },
    },

    '& .sun-logo': {
      width: 145,
    },

    '& .checkout-helper-text': {
      color: '#37474F',
      margin: '8px 0',
    },

    '& .order-bump-box': {
      padding: 20,
      border: '1px solid #ECEFF1',
      borderRadius: 8,

      '& .header': {
        display: 'flex',
      },

      '& .icon': {
        width: 30,
      },

      '& .title': {
        margin: '12px 0 12px 8px',
        lineHeight: 1.6,
      },

      '& .text': {
        color: '#292929',
      },

      '& .button': {
        color: '#0D47A1',
        paddingLeft: 0,
        '&:hover': {
          textDecoration: 'underline',
          backgroundColor: '#fff',
        },
        '&:focus': {
          outline: 'none',
        },
      },
    },
  },
  buttonDisabled: {
    opacity: 0.4,
  },
}));

export default styles;
